import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { convertToBoolean } from '@holmescorp/common';
import { lccstate, userstate } from '@holmescorp/lcc-state';
import { publish } from '@holmescorp/pub-sub';

// CSS
import css from '../../css/practice.m.css';
import { CardProperties } from '../../interfaces';
import { Card } from '../../widgets';

export interface PracticeCardProperties extends CardProperties {
	title: string;
	button_label?: string;
	button_label_complete?: string;
	subtitle?: string;
	use_direct_link?: string;
}

const factory = create({
	theme,
	userstate,
	lccstate
}).properties<PracticeCardProperties>();

export const PracticeCard = factory(({ id, properties, middleware: { theme, userstate, lccstate } }) => {
	const {
		mediaSrc = '',
		mediaTitle = '',
		title,
		subtitle = '',
		button_label = 'Begin',
		button_label_complete = 'Results',
		use_direct_link = 'false'
	} = properties();
	const themeCss = theme.classes(css);

	const { get, path } = userstate;
	const tree = get(path('practice'));

	const has_scores = () => {
		const roots: string[] = lccstate.get(lccstate.path('ditaroots'));
		return roots.some((k) => tree[k].data.percent > 0);
	};

	const label = has_scores() ? button_label_complete : button_label;

	return v('div', { id, classes: [theme.variant(), themeCss.root] }, [
		w(Card, { mediaSrc, mediaTitle }, [
			{
				content: v('div', { classes: [themeCss.content] }, [
					v('div', { classes: [themeCss.title] }, [title]),
					v('div', { classes: [themeCss.subtitle] }, [subtitle]),
					v('div', { classes: [themeCss.actions] }, [
						w(
							Button,
							{
								onClick: () => {
									convertToBoolean(use_direct_link)
										? publish('site/practice')
										: publish('active-view', 'practice');
								}
							},
							[
								{
									label
								}
							]
						)
					])
				])
			}
		])
	]);
});

export default PracticeCard;
